import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { CoreTooltip } from './CoreTooltip';

import utils = egr.wcf.utils;

export interface HeaderButtonConfig {
    stdClass: string;
    label?: string;
    active?: boolean;
    activeClass?: string;
    disabled?: boolean;
    disabledClass?: string;
    callback?: () => void;
    element?: JSX.Element;
}

interface HeaderButtonsProps {
    buttons?: Array<HeaderButtonConfig>;
}

interface HeaderButtonsState {
}

export class HeaderButtons extends BaseComponent<HeaderButtonsProps, HeaderButtonsState> {
    public render(): JSX.Element | null {
        if (this.props.buttons == null || !this.props.buttons.length) {
            return null;
        }
        return (
            <div className="header-buttons">
                {this.props.buttons.map(this.getButton)}
            </div>
        );
    }

    protected getButton = (button: HeaderButtonConfig, index: number, buttons: Array<HeaderButtonConfig>) => {
        if (button.callback) {
            return (
                <div key={index} className={this.getClassName(button, buttons.length === index + 1)} onClick={button.callback}>
                    {button.element ? button.element : null}
                    {this.tooltip(button.active === true, button.label)}
                </div>
            );
        }

        return (
            <div key={index} className={this.getClassName(button, buttons.length === index + 1)}>
                {button.element ? button.element : null}
                {this.tooltip(button.active === true, button.label)}
            </div>
        );
    };

    protected getClassName(button: HeaderButtonConfig, lastButton: boolean): string {
        const result: Array<string> = ['header-button'];
        if (button.active && button.activeClass != null) {
            result.push(button.activeClass);
        } else if (button.disabled && button.disabledClass != null) {
            result.push(button.disabledClass);
        } else {
            result.push(button.stdClass);
        }
        if (lastButton) {
            result.push('header-button-last');
        }
        return result.join(' ');
    }

    protected tooltip = (active: boolean, label?: string): JSX.Element | null => {
        if (!active && utils.string.isNotNullOrEmpty(label)) {
            return (
                <CoreTooltip config={{label: label}}/>
            );
        }
        return null;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HeaderButtons.tsx